// Minimal scroll-reveal: elements with [data-cb-reveal] get .is-in when they enter view.
// Honours prefers-reduced-motion via media query in carolbike-base.css.
(() => {
  const items = document.querySelectorAll('[data-cb-reveal]');
  if (!items.length) return;
  document.documentElement.classList.add('cb-reveal-ready');
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries, observer) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          observer.unobserve(e.target);
        }
      }
    },
    { threshold: 0.18, rootMargin: '0px 0px -10% 0px' },
  );
  items.forEach((el) => io.observe(el));
})();
